function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2012(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 19.06,
    height: 9.42,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.1775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.53,
    y: 4.71,
    fontFamily: "Arial"
  }, "\n        Highland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.42,
    width: 19.06,
    height: 9.95,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.6583333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.53,
    y: 14.395,
    fontFamily: "Arial"
  }, "\n        Norton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 19.37,
    width: 19.06,
    height: 14.82,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.705
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.53,
    y: 26.78,
    fontFamily: "Arial"
  }, "\n        Bath\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 34.19,
    width: 19.06,
    height: 15.18,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.036
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.53,
    y: 41.78,
    fontFamily: "Arial"
  }, "\n        Galax\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 49.38,
    width: 19.06,
    height: 15.54,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7266666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.53,
    y: 57.150000000000006,
    fontFamily: "Arial"
  }, "\n        Covington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 64.91,
    width: 19.06,
    height: 16.84,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.530909090909091
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.53,
    y: 73.33,
    fontFamily: "Arial"
  }, "\n        Buena_Vista\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 81.76,
    width: 19.06,
    height: 17.78,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.53,
    y: 90.65,
    fontFamily: "Arial"
  }, "\n        Craig\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 99.54,
    width: 19.06,
    height: 17.92,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.9911111111111113
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.53,
    y: 108.5,
    fontFamily: "Arial"
  }, "\n        Lexington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 117.46,
    width: 19.06,
    height: 17.98,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5685714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.53,
    y: 126.44999999999999,
    fontFamily: "Arial"
  }, "\n        Emporia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 135.44,
    width: 19.06,
    height: 18.7,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6714285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.53,
    y: 144.79,
    fontFamily: "Arial"
  }, "\n        Bedford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 154.14,
    width: 19.06,
    height: 19.66,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.812
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.53,
    y: 163.97,
    fontFamily: "Arial"
  }, "\n        Bland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 173.8,
    width: 19.06,
    height: 24.37,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.3614285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.53,
    y: 185.985,
    fontFamily: "Arial"
  }, "\n        King_and_Queen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 198.17,
    width: 19.06,
    height: 25.14,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.3825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.53,
    y: 210.73999999999998,
    fontFamily: "Arial"
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 223.31,
    width: 19.06,
    height: 28.22,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.5883333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.53,
    y: 237.42000000000002,
    fontFamily: "Arial"
  }, "\n        Charles_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 251.53,
    width: 19.06,
    height: 28.73,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.812
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.53,
    y: 265.895,
    fontFamily: "Arial"
  }, "\n        Surry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 280.26,
    width: 19.06,
    height: 29.05,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.5883333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.53,
    y: 294.78499999999997,
    fontFamily: "Arial"
  }, "\n        Rappahannock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 309.31,
    width: 19.06,
    height: 29.07,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.3825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.53,
    y: 323.845,
    fontFamily: "Arial"
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 338.38,
    width: 19.06,
    height: 31.05,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.4661538461538461
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.53,
    y: 353.905,
    fontFamily: "Arial"
  }, "\n        Manassas_Park\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 369.43,
    width: 19.06,
    height: 32.85,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7327272727272727
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.53,
    y: 385.855,
    fontFamily: "Arial"
  }, "\n        Greensville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 402.28,
    width: 19.06,
    height: 33.66,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.906
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.53,
    y: 419.10999999999996,
    fontFamily: "Arial"
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 435.94,
    width: 19.06,
    height: 35.83,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.722857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.53,
    y: 453.855,
    fontFamily: "Arial"
  }, "\n        Mathews\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 471.77,
    width: 19.06,
    height: 36,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.722857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.53,
    y: 489.77,
    fontFamily: "Arial"
  }, "\n        Radford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 507.78,
    width: 19.06,
    height: 36.27,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.1766666666666663
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.53,
    y: 525.915,
    fontFamily: "Arial"
  }, "\n        Sussex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 544.05,
    width: 19.06,
    height: 37.84,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.812
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.53,
    y: 562.9699999999999,
    fontFamily: "Arial"
  }, "\n        Essex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 581.89,
    width: 19.06,
    height: 38.24,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.1177777777777775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.53,
    y: 601.01,
    fontFamily: "Arial"
  }, "\n        Lunenburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 620.13,
    width: 19.06,
    height: 39.33,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.1177777777777775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.53,
    y: 639.795,
    fontFamily: "Arial"
  }, "\n        Charlotte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 659.46,
    width: 19.06,
    height: 40.54,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.1177777777777775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.53,
    y: 679.73,
    fontFamily: "Arial"
  }, "\n        Middlesex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.06,
    y: 0,
    width: 26.55,
    height: 30.08,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.2125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.335,
    y: 15.04,
    fontFamily: "Arial"
  }, "\n        Martinsville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.62,
    y: 0,
    width: 27.43,
    height: 30.08,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.4936363636363637
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 59.334999999999994,
    y: 15.04,
    fontFamily: "Arial"
  }, "\n        Northampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.05,
    y: 0,
    width: 27.95,
    height: 30.08,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.992857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 87.02499999999999,
    y: 15.04,
    fontFamily: "Arial"
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 0,
    width: 28.93,
    height: 30.08,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.61625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 115.465,
    y: 15.04,
    fontFamily: "Arial"
  }, "\n        Nottoway\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.93,
    y: 0,
    width: 29.17,
    height: 30.08,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.2411111111111115
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.51500000000001,
    y: 15.04,
    fontFamily: "Arial"
  }, "\n        Dickenson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159.1,
    y: 0,
    width: 29.22,
    height: 30.08,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.87
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 173.70999999999998,
    y: 15.04,
    fontFamily: "Arial"
  }, "\n        Amelia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 188.32,
    y: 0,
    width: 29.42,
    height: 30.08,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.268888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 203.03,
    y: 15.04,
    fontFamily: "Arial"
  }, "\n        Lancaster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 217.74,
    y: 0,
    width: 30.03,
    height: 30.08,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.75375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 232.755,
    y: 15.04,
    fontFamily: "Arial"
  }, "\n        Poquoson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 247.77,
    y: 0,
    width: 30.09,
    height: 30.08,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.297142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 262.815,
    y: 15.04,
    fontFamily: "Arial"
  }, "\n        Grayson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 277.86,
    y: 0,
    width: 30.31,
    height: 30.08,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.342222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 293.015,
    y: 15.04,
    fontFamily: "Arial"
  }, "\n        Alleghany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 308.17,
    y: 0,
    width: 30.75,
    height: 30.08,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5066666666666664
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 323.545,
    y: 15.04,
    fontFamily: "Arial"
  }, "\n        Falls_Church\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 338.92,
    y: 0,
    width: 31.22,
    height: 30.08,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.297142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 354.53000000000003,
    y: 15.04,
    fontFamily: "Arial"
  }, "\n        Bristol\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 370.13,
    y: 0,
    width: 31.5,
    height: 30.08,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.008
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 385.88,
    y: 15.04,
    fontFamily: "Arial"
  }, "\n        Buckingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 401.63,
    y: 0,
    width: 31.92,
    height: 30.08,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.016
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 417.59,
    y: 15.04,
    fontFamily: "Arial"
  }, "\n        Giles\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 433.55,
    y: 0,
    width: 31.94,
    height: 30.08,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.1485714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 449.52000000000004,
    y: 15.04,
    fontFamily: "Arial"
  }, "\n        Northumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 465.49,
    y: 0,
    width: 32.3,
    height: 30.08,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.016
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 481.64,
    y: 15.04,
    fontFamily: "Arial"
  }, "\n        Floyd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 497.79,
    y: 0,
    width: 32.74,
    height: 30.08,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5066666666666664
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 514.16,
    y: 15.04,
    fontFamily: "Arial"
  }, "\n        Williamsburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 530.53,
    y: 0,
    width: 32.8,
    height: 30.08,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.013333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 546.93,
    y: 15.04,
    fontFamily: "Arial"
  }, "\n        Clarke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 563.33,
    y: 0,
    width: 33.53,
    height: 30.08,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.008
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 580.095,
    y: 15.04,
    fontFamily: "Arial"
  }, "\n        Appomattox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 596.86,
    y: 0,
    width: 33.96,
    height: 30.08,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.342222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 613.84,
    y: 15.04,
    fontFamily: "Arial"
  }, "\n        Brunswick\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 630.82,
    y: 0,
    width: 34.31,
    height: 30.08,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5066666666666664
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 647.975,
    y: 15.04,
    fontFamily: "Arial"
  }, "\n        Westmoreland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 665.14,
    y: 0,
    width: 34.86,
    height: 30.08,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.013333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 682.5699999999999,
    y: 15.04,
    fontFamily: "Arial"
  }, "\n        Nelson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.06,
    y: 30.08,
    width: 35.61,
    height: 29.49,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.212857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.864999999999995,
    y: 44.824999999999996,
    fontFamily: "Arial"
  }, "\n        Patrick\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.06,
    y: 59.57,
    width: 35.61,
    height: 30.79,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.924375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.864999999999995,
    y: 74.965,
    fontFamily: "Arial"
  }, "\n        Colonial_Heights\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.06,
    y: 90.36,
    width: 35.61,
    height: 31.39,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.1390000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.864999999999995,
    y: 106.055,
    fontFamily: "Arial"
  }, "\n        Waynesboro\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.06,
    y: 121.74,
    width: 35.61,
    height: 31.86,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.655
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.864999999999995,
    y: 137.67,
    fontFamily: "Arial"
  }, "\n        King_William\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.06,
    y: 153.6,
    width: 35.61,
    height: 32.21,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.368333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.864999999999995,
    y: 169.70499999999998,
    fontFamily: "Arial"
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.06,
    y: 185.81,
    width: 35.61,
    height: 32.24,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.03
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.864999999999995,
    y: 201.93,
    fontFamily: "Arial"
  }, "\n        Hopewell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.06,
    y: 218.05,
    width: 35.61,
    height: 32.98,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5369230769230766
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.864999999999995,
    y: 234.54000000000002,
    fontFamily: "Arial"
  }, "\n        Prince_Edward\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.06,
    y: 251.04,
    width: 35.61,
    height: 33.07,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.0063636363636363
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.864999999999995,
    y: 267.575,
    fontFamily: "Arial"
  }, "\n        Southampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.06,
    y: 284.11,
    width: 35.61,
    height: 34.27,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.423333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.864999999999995,
    y: 301.245,
    fontFamily: "Arial"
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.06,
    y: 318.38,
    width: 35.61,
    height: 34.44,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.305
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.864999999999995,
    y: 335.6,
    fontFamily: "Arial"
  }, "\n        Buchanan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.06,
    y: 352.82,
    width: 35.61,
    height: 35.67,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.122
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.864999999999995,
    y: 370.655,
    fontFamily: "Arial"
  }, "\n        Scott\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.06,
    y: 388.49,
    width: 35.61,
    height: 36.33,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.561
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.864999999999995,
    y: 406.65500000000003,
    fontFamily: "Arial"
  }, "\n        Rockbridge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.06,
    y: 424.82,
    width: 35.61,
    height: 36.52,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.9025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.864999999999995,
    y: 443.08,
    fontFamily: "Arial"
  }, "\n        Page\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.06,
    y: 461.34,
    width: 35.61,
    height: 36.76,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.561
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.864999999999995,
    y: 479.71999999999997,
    fontFamily: "Arial"
  }, "\n        Winchester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.06,
    y: 498.09,
    width: 35.61,
    height: 39.1,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.45125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.864999999999995,
    y: 517.64,
    fontFamily: "Arial"
  }, "\n        New_Kent\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.06,
    y: 537.2,
    width: 35.61,
    height: 40.02,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.45125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.864999999999995,
    y: 557.21,
    fontFamily: "Arial"
  }, "\n        Staunton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.06,
    y: 577.22,
    width: 35.61,
    height: 40.43,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2372727272727273
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.864999999999995,
    y: 597.4350000000001,
    fontFamily: "Arial"
  }, "\n        King_George\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.06,
    y: 617.65,
    width: 35.61,
    height: 40.83,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5435714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.864999999999995,
    y: 638.0649999999999,
    fontFamily: "Arial"
  }, "\n        Fredericksburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.06,
    y: 658.48,
    width: 35.61,
    height: 41.52,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.087142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.864999999999995,
    y: 679.24,
    fontFamily: "Arial"
  }, "\n        Fairfax\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.67,
    y: 30.08,
    width: 37.82,
    height: 40.63,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.402857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 73.58,
    y: 50.394999999999996,
    fontFamily: "Arial"
  }, "\n        Russell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92.5,
    y: 30.08,
    width: 38.54,
    height: 40.63,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.708
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 111.77,
    y: 50.394999999999996,
    fontFamily: "Arial"
  }, "\n        Salem\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 131.04,
    y: 30.08,
    width: 38.67,
    height: 40.63,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.734
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 150.375,
    y: 50.394999999999996,
    fontFamily: "Arial"
  }, "\n        Wythe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 169.71,
    y: 30.08,
    width: 39.89,
    height: 40.63,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.98625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 189.655,
    y: 50.394999999999996,
    fontFamily: "Arial"
  }, "\n        Fluvanna\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 209.6,
    y: 30.08,
    width: 39.98,
    height: 40.63,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.9959999999999996
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 229.59,
    y: 50.394999999999996,
    fontFamily: "Arial"
  }, "\n        Smyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 249.58,
    y: 30.08,
    width: 40.42,
    height: 40.63,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.774285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 269.79,
    y: 50.394999999999996,
    fontFamily: "Arial"
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 290.01,
    y: 30.08,
    width: 41.66,
    height: 40.63,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.514444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 310.84,
    y: 50.394999999999996,
    fontFamily: "Arial"
  }, "\n        Goochland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 331.67,
    y: 30.08,
    width: 42.52,
    height: 40.63,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.514444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 352.93,
    y: 50.394999999999996,
    fontFamily: "Arial"
  }, "\n        Dinwiddie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 374.19,
    y: 30.08,
    width: 42.72,
    height: 40.63,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.07875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 395.55,
    y: 50.394999999999996,
    fontFamily: "Arial"
  }, "\n        Caroline\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.91,
    y: 30.08,
    width: 45.94,
    height: 40.63,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.804285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 439.88,
    y: 50.394999999999996,
    fontFamily: "Arial"
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 462.85,
    y: 30.08,
    width: 46.84,
    height: 40.63,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.804285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 486.27000000000004,
    y: 50.394999999999996,
    fontFamily: "Arial"
  }, "\n        Amherst\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 509.69,
    y: 30.08,
    width: 46.99,
    height: 40.63,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.1575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 533.185,
    y: 50.394999999999996,
    fontFamily: "Arial"
  }, "\n        Wise\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 556.68,
    y: 30.08,
    width: 47.18,
    height: 40.63,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.693636363636364
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 580.27,
    y: 50.394999999999996,
    fontFamily: "Arial"
  }, "\n        Mecklenburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 603.86,
    y: 30.08,
    width: 47.56,
    height: 40.63,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.07875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 627.64,
    y: 50.394999999999996,
    fontFamily: "Arial"
  }, "\n        Manassas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 651.42,
    y: 30.08,
    width: 48.58,
    height: 40.63,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.07875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 675.7099999999999,
    y: 50.394999999999996,
    fontFamily: "Arial"
  }, "\n        Powhatan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.67,
    y: 70.71,
    width: 49.46,
    height: 40.08,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.34
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.4,
    y: 90.75,
    fontFamily: "Arial"
  }, "\n        Harrisonburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.67,
    y: 110.79,
    width: 49.46,
    height: 40.89,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.089
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.4,
    y: 131.235,
    fontFamily: "Arial"
  }, "\n        Petersburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.67,
    y: 151.68,
    width: 49.46,
    height: 41.24,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.1723076923076925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.4,
    y: 172.3,
    fontFamily: "Arial"
  }, "\n        Prince_George\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.67,
    y: 192.92,
    width: 49.46,
    height: 41.25,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.15625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.4,
    y: 213.545,
    fontFamily: "Arial"
  }, "\n        Accomack\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.67,
    y: 234.17,
    width: 49.46,
    height: 42.03,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.4,
    y: 255.185,
    fontFamily: "Arial"
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.67,
    y: 276.21,
    width: 49.46,
    height: 42.29,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.048333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.4,
    y: 297.35499999999996,
    fontFamily: "Arial"
  }, "\n        Louisa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.67,
    y: 318.49,
    width: 49.46,
    height: 42.9,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.128571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.4,
    y: 339.94,
    fontFamily: "Arial"
  }, "\n        Halifax\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.67,
    y: 361.39,
    width: 49.46,
    height: 42.92,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.153333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.4,
    y: 382.84999999999997,
    fontFamily: "Arial"
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.67,
    y: 404.31,
    width: 49.46,
    height: 45.58,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.6975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.4,
    y: 427.1,
    fontFamily: "Arial"
  }, "\n        Tazewell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.67,
    y: 449.89,
    width: 49.46,
    height: 46.88,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.20888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.4,
    y: 473.33,
    fontFamily: "Arial"
  }, "\n        Botetourt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.67,
    y: 496.77,
    width: 49.46,
    height: 49.56,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.946
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.4,
    y: 521.55,
    fontFamily: "Arial"
  }, "\n        Gloucester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.67,
    y: 546.33,
    width: 49.46,
    height: 49.79,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.946
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.4,
    y: 571.225,
    fontFamily: "Arial"
  }, "\n        Shenandoah\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.67,
    y: 596.12,
    width: 49.46,
    height: 51.93,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.1825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.4,
    y: 622.085,
    fontFamily: "Arial"
  }, "\n        Danville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.67,
    y: 648.05,
    width: 49.46,
    height: 51.95,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.1825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.4,
    y: 674.025,
    fontFamily: "Arial"
  }, "\n        Culpeper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.13,
    y: 70.71,
    width: 44.51,
    height: 59.48,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.4238461538461538
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.38499999999999,
    y: 100.44999999999999,
    fontFamily: "Arial"
  }, "\n        Isle_of_Wight\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.65,
    y: 70.71,
    width: 46.59,
    height: 59.48,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1060000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 171.945,
    y: 100.44999999999999,
    fontFamily: "Arial"
  }, "\n        Charlottesville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 195.23,
    y: 70.71,
    width: 53.35,
    height: 59.48,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.67
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 221.905,
    y: 100.44999999999999,
    fontFamily: "Arial"
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 248.59,
    y: 70.71,
    width: 54.78,
    height: 59.48,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.478
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 275.98,
    y: 100.44999999999999,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 303.37,
    y: 70.71,
    width: 54.92,
    height: 59.48,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.865
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 330.83,
    y: 100.44999999999999,
    fontFamily: "Arial"
  }, "\n        Campbell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 358.29,
    y: 70.71,
    width: 57.08,
    height: 59.48,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.135
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 386.83000000000004,
    y: 100.44999999999999,
    fontFamily: "Arial"
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 415.37,
    y: 70.71,
    width: 65.57,
    height: 59.48,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.956666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 448.155,
    y: 100.44999999999999,
    fontFamily: "Arial"
  }, "\n        Pittsylvania\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 480.95,
    y: 70.71,
    width: 71.97,
    height: 59.48,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.497142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 516.935,
    y: 100.44999999999999,
    fontFamily: "Arial"
  }, "\n        Augusta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 552.91,
    y: 70.71,
    width: 72.57,
    height: 59.48,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.87
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 589.1949999999999,
    y: 100.44999999999999,
    fontFamily: "Arial"
  }, "\n        York\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 625.48,
    y: 70.71,
    width: 74.52,
    height: 59.48,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.9479999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 662.74,
    y: 100.44999999999999,
    fontFamily: "Arial"
  }, "\n        Rockingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.13,
    y: 130.19,
    width: 69.34,
    height: 65.19,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.14875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.8,
    y: 162.785,
    fontFamily: "Arial"
  }, "\n        Fauquier\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.13,
    y: 195.38,
    width: 69.34,
    height: 66.72,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.413333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.8,
    y: 228.74,
    fontFamily: "Arial"
  }, "\n        Frederick\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.13,
    y: 262.1,
    width: 69.34,
    height: 66.82,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.424444444444443
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.8,
    y: 295.51,
    fontFamily: "Arial"
  }, "\n        Lynchburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.13,
    y: 328.93,
    width: 69.34,
    height: 68.62,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.802857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.8,
    y: 363.24,
    fontFamily: "Arial"
  }, "\n        Bedford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.13,
    y: 397.54,
    width: 69.34,
    height: 73.62,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.905714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.8,
    y: 434.35,
    fontFamily: "Arial"
  }, "\n        Roanoke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.13,
    y: 471.16,
    width: 69.34,
    height: 75.19,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.934
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.8,
    y: 508.755,
    fontFamily: "Arial"
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.13,
    y: 546.35,
    width: 69.34,
    height: 75.61,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.934
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.8,
    y: 584.155,
    fontFamily: "Arial"
  }, "\n        James_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.13,
    y: 621.96,
    width: 69.34,
    height: 78.04,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.905714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.8,
    y: 660.98,
    fontFamily: "Arial"
  }, "\n        Suffolk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 173.47,
    y: 130.19,
    width: 73.57,
    height: 79.35,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.356999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 210.255,
    y: 169.865,
    fontFamily: "Arial"
  }, "\n        Portsmouth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 247.04,
    y: 130.19,
    width: 82.05,
    height: 79.35,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.335714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 288.065,
    y: 169.865,
    fontFamily: "Arial"
  }, "\n        Roanoke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 329.09,
    y: 130.19,
    width: 86.36,
    height: 79.35,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.816666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 372.27,
    y: 169.865,
    fontFamily: "Arial"
  }, "\n        Albemarle\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 415.45,
    y: 130.19,
    width: 92.88,
    height: 79.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.6125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 461.89,
    y: 169.865,
    fontFamily: "Arial"
  }, "\n        Spotsylvania\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 508.33,
    y: 130.19,
    width: 94.61,
    height: 79.35,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.335714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 555.635,
    y: 169.865,
    fontFamily: "Arial"
  }, "\n        Hanover\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 602.94,
    y: 130.19,
    width: 97.06,
    height: 79.35,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.91875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 651.47,
    y: 169.865,
    fontFamily: "Arial"
  }, "\n        Stafford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 173.47,
    y: 209.54,
    width: 104.7,
    height: 80.73,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.532857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 225.82,
    y: 249.905,
    fontFamily: "Arial"
  }, "\n        Hampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 173.47,
    y: 290.27,
    width: 104.7,
    height: 89.13,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.913
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 225.82,
    y: 334.835,
    fontFamily: "Arial"
  }, "\n        Alexandria\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 173.47,
    y: 379.4,
    width: 104.7,
    height: 96.46,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.038333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 225.82,
    y: 427.63,
    fontFamily: "Arial"
  }, "\n        Newport_News\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 173.47,
    y: 475.86,
    width: 104.7,
    height: 105.68,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.957142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 225.82,
    y: 528.7,
    fontFamily: "Arial"
  }, "\n        Norfolk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 173.47,
    y: 581.54,
    width: 104.7,
    height: 118.46,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.0875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 225.82,
    y: 640.77,
    fontFamily: "Arial"
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278.17,
    y: 209.54,
    width: 120.02,
    height: 116.96,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.696
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 338.18,
    y: 268.02,
    fontFamily: "Arial"
  }, "\n        Chesapeake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 398.2,
    y: 209.54,
    width: 127.83,
    height: 116.96,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.995555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 462.115,
    y: 268.02,
    fontFamily: "Arial"
  }, "\n        Arlington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 526.03,
    y: 209.54,
    width: 173.97,
    height: 116.96,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.708571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 613.015,
    y: 268.02,
    fontFamily: "Arial"
  }, "\n        Loudoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278.17,
    y: 326.5,
    width: 174.75,
    height: 118.03,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.861428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 365.545,
    y: 385.515,
    fontFamily: "Arial"
  }, "\n        Henrico\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278.17,
    y: 444.52,
    width: 174.75,
    height: 124.39,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.365833333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 365.545,
    y: 506.715,
    fontFamily: "Arial"
  }, "\n        Chesterfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278.17,
    y: 568.91,
    width: 174.75,
    height: 131.09,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.36357142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 365.545,
    y: 634.4549999999999,
    fontFamily: "Arial"
  }, "\n        Prince_William\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 452.92,
    y: 326.5,
    width: 247.08,
    height: 101.17,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.226428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 576.46,
    y: 377.085,
    fontFamily: "Arial"
  }, "\n        Virginia_Beach\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 452.92,
    y: 427.67,
    width: 247.08,
    height: 272.33,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 35.29714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 576.46,
    y: 563.835,
    fontFamily: "Arial"
  }, "\n        Fairfax\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2012);
export default __webpack_public_path__ + "static/media/2012.195d13931b22dc4b73c3a882d7f2d5fd.svg";
export { ForwardRef as ReactComponent };